import React, { FC, useState } from 'react';
import { Button, Modal, Table } from 'antd';

interface Props {
  loan: any;
  visible: boolean;
  onCancel: any;
  addressTable: any;
  editNote: any;
  dataNote: any;
}

const ConfirmNoteModal: FC<Props> = ({
  loan,
  visible,
  onCancel,
  addressTable,
  editNote,
  dataNote,
}) => {
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Loan Id',
      dataIndex: 'id',
      key: 'id',
      width: '10%',
    },
    {
      title: 'App Id',
      dataIndex: 'appId',
      key: 'appId',
      width: '10%',
    },
  ];

  const submitOne = async () => {
    setLoading(true);
    const { id, appId } = loan;
    const values = [{ loanId: id, appId, ...dataNote }];
    await editNote(values);
    setLoading(false);
  };

  const submitAll = async () => {
    setLoading(true);
    const { address } = addressTable;
    const values = address.map((data: { id: any; appId: any }) => ({
      loanId: data.id,
      appId: data.appId,
      ...dataNote,
    }));
    await editNote(values);
    setLoading(false);
  };

  return (
    <Modal
      title="Address"
      width={1000}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel} danger ghost>
          ยกเลิก
        </Button>,
        <Button key="submit" onClick={submitOne} type="primary" loading={loading} ghost>
          สัญญาเดียว
        </Button>,
        <Button key="allsubmit" onClick={submitAll} type="primary" loading={loading}>
          ทุกสัญญา
        </Button>,
      ]}
    >
      <Table dataSource={addressTable?.address} columns={columns} pagination={false} />
    </Modal>
  );
};

export default ConfirmNoteModal;
